export default "__VITE_ASSET__30eee20c__"